import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';


import AlertCardPendingCredentialContainer from 'containers/resources/AlertCardPendingCredentialContainer';

import Icon from 'components/ui/element/Icon';

import {NOTIFICATION_TYPE, TYPE_NOTIFICATION_CARD} from 'modules/notifications';

import {prevDefStopProp, isMobile} from 'util/utils';

import 'style/components/notification/notification.scss';

const _timeOptions = {
    hour:   '2-digit',
    minute: '2-digit',
    second: '2-digit'
};

/**
 * Get the name for the icon since the type
 * @param {String} type The type of the notification to show
 * @return {string} The name of the icon to show
 */
const _getIconName = type => {
    switch (type) {
    case NOTIFICATION_TYPE.ERROR:
        return 'times-circle';
    case NOTIFICATION_TYPE.WARNING:
        return 'warning';
    case NOTIFICATION_TYPE.SUCCESS:
        return 'check';
    case NOTIFICATION_TYPE.INFO:
        return 'info-circle';
    }

    return '';
};

/** Component to render a notification */
class Notification extends Component {

    static propTypes = {
        notification: PropTypes.object.isRequired, // The notification to show
        onRemove:     PropTypes.func, // Listener when remove button was pressed
        onDownload:   PropTypes.func, // Function when the user wants download something
        isAlert:      PropTypes.bool // True when the notification item was an alert
    };

    /**
     * Set this to handlers
     */
    componentWillMount() {
        this.handleRemove = this.handleRemove.bind(this);
    }

    /**
     * Remove the passed notification
     * @param {Event} e The event object
     */
    handleRemove(e) {
        const {notification, onRemove} = this.props;

        e.preventDefault();
        e.stopPropagation();

        onRemove && onRemove(notification);
    }

    renderText() {
        const {notification, intl: {formatMessage}, onDownload} = this.props;
        const url = notification.extraData ? notification.extraData.url : null;
        const filename = notification.extraData ? notification.extraData.filename : null;


        if (notification.text && typeof notification.text === 'object') {
            const {idFormat} = notification.text;
            const params = {...notification.text};

            delete params[idFormat];

            return formatMessage({id: idFormat}, params);
        }

        if (url) {
            return (
                <div className={'download-button'}>
                    <span>{formatMessage({id: 'download.notification'})}</span>
                    <br/>
                    <span className={'clicked-link'} onClick={e => onDownload(e, url, filename)}>{filename}</span>

                </div>
            );
        }

        return notification.text ? formatMessage({id: notification.text}) : null;

    }

    renderRemove() {
        const {isAlert} = this.props;
        let icon = '';

        if (isAlert) {
            if (!isMobile()) {
                icon = 'close';
            }
        } else {
            icon = 'trash-o';
        }

        return icon ?
            <Icon className="notification-close" name={icon} onClick={this.handleRemove} />
            : null;
    }

    renderTitle() {
        const {notification, intl: {formatMessage}} = this.props;

        if (notification.title) {

            if (notification.translatable) {
                return formatMessage({id: `title.alert.${notification.title}`});
            }

            return formatMessage({id: notification.title});
        }

        return null;
    }

    renderCustomComponent() {
        const {notification} = this.props;

        if (notification.component === TYPE_NOTIFICATION_CARD.PENDING_CREDENTIAL) {
            return <AlertCardPendingCredentialContainer accounts={notification.extraData} type={notification.type}/>;
        }

        return null;

    }

    render() {
        const {notification, intl: {formatDate}, isAlert} = this.props;

        return (
            <div className={`notification ${isAlert ? 'alert' : ''} ${notification.read ? '' : 'unread'} ${notification.type}`} onClick={prevDefStopProp}>
                <header>
                    <Icon className="notification-icon" name={_getIconName(notification.type)} />
                    <div className="notification-title">{this.renderTitle()}</div>
                    <div className="notification-datetime">{formatDate(notification.datetime, _timeOptions)}</div>
                </header>
                <div className="notification-text">
                    {this.renderText()}
                    {this.renderCustomComponent()}
                </div>
                {this.renderRemove()}
            </div>
        );


    }

}

const mapStateToProps = state => ({
    notifications: state.notifications
});

export default injectIntl(connect(mapStateToProps)(Notification));



// WEBPACK FOOTER //
// ./src/components/notifications/Notification.jsx